export default "__VITE_ASSET__CbQ0ujjV__"